var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.9375 27.9375C0.9375 28.5598 1.44023 29.0625 2.0625 29.0625H27.9375C28.5598 29.0625 29.0625 28.5598 29.0625 27.9375V13.1719H0.9375V27.9375ZM27.9375 3.46875H22.0312V1.21875C22.0312 1.06406 21.9047 0.9375 21.75 0.9375H19.7812C19.6266 0.9375 19.5 1.06406 19.5 1.21875V3.46875H10.5V1.21875C10.5 1.06406 10.3734 0.9375 10.2188 0.9375H8.25C8.09531 0.9375 7.96875 1.06406 7.96875 1.21875V3.46875H2.0625C1.44023 3.46875 0.9375 3.97148 0.9375 4.59375V10.7812H29.0625V4.59375C29.0625 3.97148 28.5598 3.46875 27.9375 3.46875Z",
    fill: "#6DD8CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGreen);
export default __webpack_public_path__ + "static/media/calendar-green.32c6e515eb1d2f7759a428f0895b6de3.svg";
export { ForwardRef as ReactComponent };